import { render } from "./OneCustomerComponent.vue?vue&type=template&id=20ced8a2&scoped=true"
const script = {}

import "./OneCustomerComponent.vue?vue&type=style&index=0&id=20ced8a2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anupashyam\\Downloads\\gitlabs - rel path oops\\virtuallab-oop\\exp-10\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20ced8a2"]])

export default __exports__